import React from 'react';
import './test-completed.css'
import { Link } from "react-router-dom";
import { useAuthState } from '../../../Context';
import ProgressBar from '../../ProgressBar/ProgressBar';
import Otsukare from "../../../Images/otsukare@2x.png";
let testProgressBar = 4

export default function TestCompleted({score}) {
  const userDetails = useAuthState();
  const user = userDetails.user;
  return (
    <>
      <ProgressBar testProgressBar={testProgressBar}/>
      <div className="color-test-completed">
      <div className="head welcome-text-button-results-container">
          <div className="welcome-text-container">
            <h1>処理機能テスト（後半）</h1>
          </div>
        </div>


        <div className="text-box">
        <div className="flex">
            <div className="exam-icon">
              <img src={Otsukare} alt="おつかれさまでした" />
            </div>
            <div className='instructions-text'>
          <h2 className="instructions-text-center">おつかれさまでした。</h2>
          {user.is_admin && (
            <p className="instructions-text-center">
              Your Total Score is: {score}
            </p>
          )}
        </div>

</div>
</div>

                <div className="startText">次のテストに進みます。</div>

        <Link to="/test/word-memory-2" className="continue-button"><h2>次へ</h2></Link>
        {/* <button className="continue-button" >Continue</button> */}
      </div>
    </>
  )
}
